var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReportMess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Interaction field") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.86969472,1.35531915 C3.34373299,1.35531915 1.29603643,3.40909379 1.29603643,5.94255319 L1.29603643,18.5574468 C1.29603643,21.0909062 3.34373299,23.1446809 5.86969472,23.1446809 L19.0189623,23.1446809 C21.544924,23.1446809 23.5926206,21.0909062 23.5926206,18.5574468 L23.5926206,5.94255319 C23.5926206,3.40909379 21.544924,1.35531915 19.0189623,1.35531915 L5.86969472,1.35531915 Z M5.86969472,0.208510638 L19.0189623,0.208510638 C22.1764144,0.208510638 24.7360352,2.77572893 24.7360352,5.94255319 L24.7360352,18.5574468 C24.7360352,21.7242711 22.1764144,24.2914894 19.0189623,24.2914894 L5.86969472,24.2914894 C2.71224256,24.2914894 0.152621858,21.7242711 0.152621858,18.5574468 L0.152621858,5.94255319 C0.152621858,2.77572893 2.71224256,0.208510638 5.86969472,0.208510638 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7584722,5.36914894 C13.1612457,5.36914894 13.7837138,5.87879705 13.7837138,6.27923486 L13.4175561,14.6520254 C13.4175561,15.0524632 13.0880142,15.3800941 12.6852407,15.3800941 C12.2824672,15.3800941 11.9529253,15.0524632 11.9529253,14.6520254 L11.7698464,6.3156383 C11.7698464,5.91520049 12.3923145,5.36914894 12.7584722,5.36914894 Z M12.6852407,17.200266 C13.3077088,17.200266 13.7837138,17.6735106 13.7837138,18.2923691 C13.7837138,18.9112275 13.3077088,19.3844722 12.6852407,19.3844722 C12.0627726,19.3844722 11.5867676,18.9112275 11.5867676,18.2923691 C11.5867676,17.6735106 12.0627726,17.200266 12.6852407,17.200266 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---chating---Menu",
    transform: "translate(-24.000000, -556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(8.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field",
    transform: "translate(15.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Messages"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReportMess);
export default __webpack_public_path__ + "static/media/icReportMess.8644d833a5125caad8f2978d2ff91051.svg";
export { ForwardRef as ReactComponent };